<template>
  <router-link
    class="topic-item-component transition-wrapper"
    :to="{ name: 'topic_view', params: { id: item.id } }"
    :target="linkTarget"
  >
    <div class="image-wrapper top">
      <img
        v-lazy="item.thumbnail"
        class="thumbnail"
        :alt="`微博营销 ${item.title}`"
        :title="`微博营销 ${item.title}`"
      />
    </div>
    <div class="info bottom app-flex-column">
      <span class="time font-14">
        {{ item.release_time | relativeTimeFormat('M月D日') }}
      </span>
      <p class="title font-18">{{ item.title }}</p>
      <div class="btn-box">
        <div class="more-btn font-color-primary font-14">查看专题</div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    // 是否需要在新tab页打开
    linkTarget: { type: String, default: '_seft' }
  }
}
</script>

<style lang="scss" scoped>
.topic-item-component {
  @include transitionCard;
  width: 278px;
  margin-bottom: 30px;
  color: $text-color-default;
  .image-wrapper {
    width: 100%;
    height: 139px;
    .thumbnail {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 139px;
      object-fit: cover;
    }
  }
  .info {
    height: 140px;
    padding: 14px 24px 0 24px;
    .title {
      margin: 12px 0 20px 0;
    }
    .btn-box {
      text-align: center;
      display: none;
      .more-btn {
        width: 120px;
        height: 38px;
        line-height: 36px;
        display: inline-block;
        border: 1px solid $primary-color;
        background-color: $white;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }

  /**
  图片增加15%黑色遮罩，图片上移20px，图片区域减少50px高
  文字增加50px高度，底色色值#ffffff
  */
  &:hover {
    .image-wrapper {
      height: 79px;
      .thumbnail {
        margin-top: -20px;
      }
    }
    .info {
      height: 190px;
      .btn-box {
        display: block;
      }
    }
  }
}
</style>
